const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/guest/Login'),
  },
]

module.exports = routes
